import React from "react";
import siteConfig from "../siteConfig";
import cityPageContent from "../data/city-page-content";

/**
 * Office facts card ("Address / Office Phone / Availability / ...") from the
 * Wyoming design, Figma node 439:1477.
 *
 * Rows come from cityPageContent[city][service].officeCard. Rows marked
 * `valueFrom` resolve against siteConfig at render time so the address and
 * phone are not duplicated here — a second copy of NAP data is what
 * conflicting-NAP looks like to Google, which the city pages already guard
 * against elsewhere. Renders nothing for pages that have no officeCard defined.
 */
const CityOfficeCard = ({ city, service }) => {
  const { officeCard } = cityPageContent.forPage(city, service);
  if (!officeCard || !officeCard.length) return null;

  const office = siteConfig.officeForCity(city);
  const phone = siteConfig.phoneForCity(city);

  const resolve = (row) => {
    if (row.valueFrom === "phone") return phone;
    if (row.valueFrom === "address") {
      return office ? `${office.address}, ${office.zip}` : null;
    }
    return row.value;
  };

  const rows = officeCard
    .map((row) => ({ label: row.label, value: resolve(row), isPhone: row.valueFrom === "phone" }))
    .filter((row) => row.value);

  return (
    <div className="bg-[#f8f9fb] border border-neutral-200 rounded-2xl p-6 md:p-8 not-prose">
      <dl className="m-0 divide-y divide-neutral-200">
        {rows.map((row) => (
          <div
            key={row.label}
            className="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1 py-3 first:pt-0 last:pb-0"
          >
            <dt className="m-0 font-semibold text-brand-700 text-base">{row.label}</dt>
            <dd className="m-0 text-[#667085] text-base text-right">
              {row.isPhone ? (
                <a
                  href={`tel:${siteConfig.phoneE164(row.value)}`}
                  className="text-[#667085] hover:text-brand-600 no-underline"
                >
                  {row.value}
                </a>
              ) : (
                row.value
              )}
            </dd>
          </div>
        ))}
      </dl>
    </div>
  );
};

export default CityOfficeCard;
